import axios from 'axios';

export async function getUsers(params: any) {
  const response = await axios.get('/api/admin/users', {
    params,
  });

  return response.data;
}

export async function createPlanner(payload: any) {
  const response = await axios.post('/api/admin/users/planner', payload);
  return response.data;
}

export async function createShop(payload: any) {
  const response = await axios.post('/api/admin/shop', payload);
  return response.data;
}

export async function updateUser(userId: any, payload: any) {
  const response = await axios.put(`/api/admin/users/${userId}`, payload);
  return response.data;
}

export async function deleteUser(userId: any) {
  const response = await axios.delete(`/api/admin/users/${userId}`);
  return response.data;
}